import React from 'react';
import classes from './MovieThumbnail.scss';
import PropTypes from 'prop-types';

const MovieThumbnail = ({ image, stock, ...other }) => {
  const thumbStyle = { backgroundImage: image ? `url(/data/images/${image})` : 'none' };
  return (
    <div
      className={`${classes['movie-thumbnail']} ${stock && classes['stock']}`}
      style={thumbStyle}
      {...other}
    >
    </div>
  );
};

MovieThumbnail.propTypes = {
  image: PropTypes.string.isRequired,
  stock: PropTypes.bool.isRequired
};

MovieThumbnail.defaultProps = {
  stock: false
};

export default MovieThumbnail;
